<template>
    <div class="data_09m" ref="mydata">
        <div class="main_view">
            <div :class="`item delay1 ${show?'show':'hide'}`">
                <div class="item_img">
                    <img src="../../public/img/contentBox1_info_img1.png" alt="" srcset="">
                </div>
                <div class="item_text">
                    <div class="number">
                        <div class="font_number">
                            {{number1_c}}
                            <div class="unit">{{$t('件')}}</div>
                        </div>
                    </div>
                    <div class="min_text">{{$t('医用防护服日产')}}</div>
                </div>
            </div>
            <div :class="`item delay2 ${show?'show':'hide'}`">
                <div class="item_img">
                    <img src="../../public/img/contentBox1_info_img2.png" alt="" srcset="">
                </div>
                <div class="item_text">
                    <div class="number">
                        <div class="font_number">
                            {{number2}}
                            <div class="unit">{{$t('余个')}}</div>
                        </div>
                    </div>
                    <div class="min_text">{{$t('产品覆盖的国家')}}</div>
                </div>                
            </div>
            <div :class="`item delay3 ${show?'show':'hide'}`">
                <div class="item_img">
                    <img src="../../public/img/contentBox1_info_img3.png" alt="" srcset="">
                </div>
                <div class="item_text">
                    <div class="number">
                        <div class="font_number" >
                            {{number3}}
                            <div class="unit">{{$t('余种')}}</div>
                        </div>
                    </div>
                    <div class="min_text">{{$t('产品种类')}}</div>
                </div>                
            </div>          
        </div>
    </div>
</template>
<script>
import throttle from '../plugins/throttle.js';
export default {
    data () {
        return {
            observer: null,
            scrollHandle: throttle(this.scrollThrottle, 200, this, true),
            show:false,
            timer:null,
            number1:0,
            number2:0,
            number3:0,            
        };
    },
    mounted () {
        // 判断是否支持 IntersectionObserver
        if ('IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
            this.observer = new IntersectionObserver(entries => {
                if (entries[0].intersectionRatio > 0) {
                    console.log('进入可视区域');
                    this.show = true
                } else {
                    console.log('移出可视区域');
                    // do something
                    this.show = false
                }
            });
        }
        this.startObserve()
        
    },
    destroyed(){
        this.endObserve()
    },
    watch:{
        show(value){
            if(value){
                this.init()
                this.timer = setInterval(()=>{
                    if(this.number1<70000){
                        this.number1 += 1000
                    }
                    if(this.number2<50){
                        this.number2++                    
                    }
                    if(this.number3<100){
                        this.number3+=2                                   
                    }
                },50)
            }else{
                clearInterval(this.timer)
                this.init()
            }
        }
    },
    computed:{
        number1_c(){
            let i = parseInt(this.number1/1000)
            let j = this.number1%1000
            if(i==0){
                return j
            }else{
                if(j!=500){
                    j = '000'
                }
                return i+','+j
            }
        }
    },
    methods: {
        init(){
            this.number1 = 0
            this.number2 = 0
            this.number3 = 0
        },
        startObserve () {
            if (this.observer) {
                this.observer.observe(this.$refs.mydata);
            } else {
                window.addEventListener('scroll', this.scrollHandle, true);
            }
        },
        endObserve () {
            if (this.observer) {
                this.observer.disconnect();
            } else {
                window.removeEventListener('scroll', this.scrollHandle, true);
            }
        },
        scrollThrottle () {
            const offset = this.$refs.getBoundingClientRect();
            const offsetTop = offset.top;
            const offsetBottom = offset.bottom;
            const offsetHeight = offset.height;
            // 进入可视区域
            if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
                console.log('进入可视区域');
                // do something
            } else {
                console.log('移出可视区域');
                // do something
            }
        }
    }
}
</script>
<style lang="less" scoped>
.data_09m{
    min-height: 23vw;
    width: 100vw;
    .hide{
        transform: translateY(-50%);
        opacity: 0;
    }
    .show{
        transform: translateY(0);
        opacity: 1;
    }
    .delay1{
        transition: 0.5s all ease-in 0s;
    }
    .delay2{
        transition: 0.5s all ease-in 0.15s;
    }
    .delay3{
        transition: 0.5s all ease-in 0.3s;
    }
    .main_view{
        width: 62.5vw;
        min-height: 23vw;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .item{
            
            .item_img{
                width: 100%;
                height: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    height: 90%;
                }
            }
            .item_text{
                width: 100%;
                height: 50%;
                .number{
                    width: 100%;
                    height: 60%;
                    position: relative;
                    .font_number{
                        display: inline-block;
                        width: fit-content;
                        font-family: 'YH';
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                        color: #017CA4;
                        display: flex;
                        align-items: flex-end;
                        .unit{
                            margin-left: 15px;
                            color: #6B6B6B;
                        }
                    }
                }
                .min_text{
                    text-align: center;
                    color: #6B6B6B;                 
                }
            }
        }
        @media screen and (min-width: 0px) and (max-width: 480px){
        // 在这里写小屏幕设备的样式
            .item{
                width: 62.5vw;
                height: 80vw;
                margin-bottom: 10vw;
                .font_number{
                    font-size: 10vw;
                    line-height: 10vw;  
                    .unit{
                        font-size: 6vw;
                        line-height:6vw;                        
                    }   
                }
                .min_text{
                    font-size: 4.5vw;
                    line-height:4.5vw;                                  
                }
            }
        }

        @media only screen and (min-width: 481px) and (max-width: 1024px){
        // 这里写宽度大于321px小于1024px的样式(一般是平板电脑)
            .item{
                width: 18vw;
                height: 23vw;
                .font_number{
                    font-size: 3.5vw;
                    line-height: 3.5vw;
                    .unit{
                        font-size: 1.8vw;
                        line-height: 1.8vw;                        
                    }                
                }
                .min_text{
                    font-size: 1.3vw;
                    line-height:1.3vw;                                  
                }
            }
        }

        @media only screen and (min-width: 1029px){
            // 这里写pc客户端的样式
            .item{
                width: 18vw;
                height: 23vw;
                .font_number{
                    font-size: 3.5vw;
                    line-height: 3.5vw;     
                    .unit{
                        font-size: 1.8vw;
                        line-height: 1.8vw;                                                
                    }         
                }
                .min_text{
                    font-size: 1.3vw;
                    line-height:1.3vw;                                  
                }
                        
            }
            
        }
        
    }
}
</style>
